import { render } from "./StoreMasterUploadList.vue?vue&type=template&id=196ffa2e"
import script from "./StoreMasterUploadList.vue?vue&type=script&lang=js"
export * from "./StoreMasterUploadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__